module.exports = __webpack_public_path__ + "static/media/german_troops_railroad.d89f5ffd.png";